import Vue from "vue";
import Component from "vue-class-component";
import ABaseComponent from 'Components/Base/ABaseComponent';
import { PorterViewModel, CustomerBarcodeStatusCode } from "Api/CoreApi";
import { Prop } from "vue-property-decorator";
import ApiProvider from "Api/ApiProvider";

@Component({
    template: "#edit-porter-function-confirm-modal-template"
})
export default class PorterEditModalComponent extends ABaseComponent
{
    public porterList: PorterViewModel[] = null;
    public customerBarcodeStatusCodes: CustomerBarcodeStatusCode[] = null;
    public showPorterDropdown: boolean = false;

    mounted() {
        const self = this;
        const client = ApiProvider.getApiClient();
        // get list of porters
        client.getPorterList()
            .then(result => {
                self.porterList = result.porters;
            });

        // get list of barcode statuscodes
        client.getCustomerBarcodeStatusCodes()
            .then(result => {
                self.customerBarcodeStatusCodes = result;
            });

        self.setLoaded();

        $('.porters-select').select2();

        // resets form on closed fancybox
        $('[data-fancybox]').fancybox({
            'afterClose': function (instance, current) {
                // resets form
                $(current.src).find('form').trigger('reset');

                // reset porters dropdown
                $('.porters-select').val(null).trigger('change');

                self.showPorterDropdown = false;
            }
        });
    }

    async togglePorterFilter() {
        this.showPorterDropdown = true;
    }

    async download(submitEvent: any) {
        try {
            var parent = this.$parent as any;
            var mail = parent.mail;
            var data = $(submitEvent.target).serialize();

              
            $.fancybox.close();
        } catch (e) {
            this.setError(e);
        }

        this.setLoaded();
    }

}




Vue.component('porter-edit-modal', PorterEditModalComponent);